module.exports = __webpack_public_path__ + "img/zh.a1fab130.png";